module.exports = __webpack_public_path__ + "files/Trustami_VERITAS_Bachelor_Master_Thesis__BIAS_within_Datasets.pdf";